export default (txt: string | undefined) => {
  if (!txt) return true;

  // Check if it starts with "09" and has a length of 11
  if (txt.startsWith("09") && txt.length === 11) {
    return true;
  }

  // Check if it's a valid email address
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(txt)) {
    return true;
  }

  return false;
};